'use client';

import { c as _c } from "react/compiler-runtime";
import { SessionProvider } from 'next-auth/react';
export function AuthProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SessionProvider>{children}</SessionProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}